var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rests_times" },
    [
      _c(
        "b-overlay",
        { attrs: { show: _vm.is_load, rounded: "sm" } },
        [
          _vm.api_load
            ? _c("times", { attrs: { times: this.times_data } })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "sync_it w-100 mt-4" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary waves-effect waves-themed w-100",
                attrs: { type: "button" },
                on: { click: _vm.sync_times },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.__t("SYNC_TIME")) +
                    "\n            "
                ),
              ]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }